const config = {
    development: {
        apiBaseURL: "https://localhost:7159", // URL de desarrollo
        publicKey: "pub_test_WdeaXCPdJezjynBVykx7eIidTp1Xtc1k",
        integritySecret: "test_integrity_Zn33oZySfwFGnv3GpFo9nN8iZr1qhtNP"
    },
    production: {
        apiBaseURL: `${window.location.protocol}//${window.location.host}`, // URL de producción
        publicKey: "pub_prod_8HJGDZuTm0lkYzyUeuUV3PXsSdndx9nJ",
        integritySecret: "prod_integrity_L4gVACSljR0oGHMMKPvpKeZkDbqlMf2R"
    },
};

export const getConfig = () => {
    const env = process.env.REACT_APP_ENV || "development"; // Usa "development" si no se define
    return config[env];
};
